export const MULTI_ENUM_DELIMITER = ';';
export const APPEND_MULTI_ENUM_DELIMITER = ';';
export const REMOVE_MULTI_ENUM_DELIMITER = '?^';